import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Redirect = ({ children }) => {
  const { state } = useContext(AuthContext);
  const router = useNavigate();
  if (state?.user?.role) {
    if (state?.user?.role == 'admin') {
      router('/admin');
    } else if (state?.user?.role == 'student') {
      router('/student');
    } else if (state?.user?.role == 'parent') {
      router('/parent');
    } else if (state?.user?.role == 'superadmin') {
      router('/superadmin');
    }
  }
  return children;
};

export default Redirect;
